<div
  class="monogram"
  [style.height.rem]="size"
  [style.width.rem]="size"
  [style.backgroundColor]="color"
>
  <!--suppress AngularNgOptimizedImage -->
  <img *ngIf="picture" [src]="picture | picture" alt="User image" />
  <span *ngIf="!picture" [style.fontSize]="fontSize">{{ monogram }}</span>
</div>
